module.exports = __webpack_public_path__ + "static/media/PlosneCovidTestovanie-banner.41a63269.png";